const Form034EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInformation: "Application Information",
        confirmation: "Confirmation",
    },
    noteList: {
        title: "Reference Materials:",
        note1: "<p>EDB Circular Nos. {{circularNoPrimary}} (NET Scheme in Primary Schools)</p> <a target='_blank' rel='noreferrer' href='{{note2Attachment}}'>{{note2Attachment}}</a>",
        note3: "<p>EDB Circular Nos. {{circularNoSecondary}} (Enhanced NET Scheme in Secondary Schools)</p> <a target='_blank' rel='noreferrer' href='{{note4Attachment}}'>{{note4Attachment}}</a>",
        note5: "“Sample Memorandum on the Terms and Conditions of Service for Appointment as Teachers under the NET Scheme in Primary Schools / the Enhanced NET Scheme in Secondary Schools (applicable to {{schoolYear}} school year)”",
        note7: "<p>Primary Schools:</p> <a target='_blank' rel='noreferrer' href='{{note7Attachment}}'>{{note7Attachment}}</a>",
        note9: "<p>Secondary Schools:</p> <a target='_blank' rel='noreferrer' href='{{note9Attachment}}'>{{note9Attachment}}</a>",
        number1: "1.",
        number2: "2.",
        number3: "3.",
        number4: "4.",
        number5: "5.",
        number6: "6.",
        number7: "7.",
        number8: "8.",
        number9: "9.",
        number10: "10.",
        number11: "11.",
        numbera: "(a)",
        numberb: "(b)",
        numberc: "(c)",
    },
    maritalStatusOption: {
        single: "single",
        marriedAc: "married, accompanied by spouse",
        marriedUnac: "married, unaccompanied by spouse",
        separated: "separated",
        widowed: "widowed",
        divorced: "divorced",
    },
    housingBenefitsOption: {
        public: "Public Rental Housing",
        homeOwnership: "Home Ownership Scheme",
        homePurchase: "Home Purchase Loan",
        staff: "Staff Quarters",
        others: "Others (please specify)",
    },
    housingBenefits: {
        yes: "Yes",
        no: "No",
    },
    label: {
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        section1: "Section 1: Personal Particulars",
        section2: "Section 2: Details of Residence",
        section3: "Section 3: Declaration by Applicant and Spouse",
        aidedOrCaput: "School Type",
        textBeforeSchoolName: "To: Supervisor/Principal of",
        // section1
        titleOfApplicant: "Title of applicant",
        fullNameOfApplicant: "Full name of applicant",
        textAfterSchoolName: "(School)",
        nationality: "Nationality/Nationalities held",
        passportNumber: "Passport number",
        maritalStatus: "Marital status",
        titleOfSpouse: "Title of spouse",
        fullNameOfSpouse: "Full name of spouse",
        spouseOccupation: "Spouse's occupation",
        spouseEmployer: "Spouse's employer",

        // section2
        residentialAddress: "Residential address",
        housingBenefits:
            "Housing benefits (in cash or in kind) currently received by me / spouse",
        section2Conditions:
            "I enclose herewith the original or a copy of my proof of address issued within the last three months.",
        housingBenefitsOthers: "others",
        // section3
        note2One:
            "I confirm that I have read and understood the EDB Circular No. {{circularNoPrimary}} including the Notes for Completing {{PNET}}-Forms A-E and the stipulations related to Special Allowance in the Memorandum on the Terms and Conditions of Service.  I agree to abide by the provisions of the Special Allowance for Native-speaking English Teachers employed {{netPrimary}}.",
        note2Two:
            "I confirm that I have read and understood the EDB Circular No. {{circularNoSecondary}} including the Notes for Completing {{NET}}-Forms A-E and the stipulations related to Special Allowance in the Memorandum on the Terms and Conditions of Service.  I agree to abide by the provisions of the Special Allowance for Native-speaking English Teachers employed under {{enhancedSecondary}}.",
        note3One:
            "I declare that I am not receiving any housing benefits in cash or in kind under my terms of employment with the Government, any Publicly-funded Organization or other sources to rent or acquire accommodation in Hong Kong.",
        note3Two:
            "I and my spouse declare that we are not receiving any housing benefits in cash or in kind under my / my spouse’s terms of employment with the Government, any Publicly-funded Organization or other sources to rent or acquire accommodation in Hong Kong.",
        note4One:
            "I declare that the information provided in this application form is true and correct. I understand that if I give any false or incorrect information / declaration, I will be subject to the consequences, including disqualification from all forms of fringe benefits under the NET Scheme, being required to refund the benefits to the Government, and being subject to disciplinary punishment and / or termination of contract and / or legal proceedings and / or criminal prosecution.",
        note4Two:
            "I and my spouse declare that the information provided in this application form is true and correct. We understand that if I and my spouse give any false or incorrect information / declaration, we will be subject to the consequences, including disqualification from all forms of fringe benefits under the NET Scheme, being required to refund the benefits to the Government, and being subject to disciplinary punishment and / or termination of contract and / or legal proceedings and / or criminal prosecution.",
        note5: "I undertake to report to the school within 30 days any changes of my marital status and family particulars that might affect my entitlement to the Special Allowance.",
        note6: "I undertake to inform you and to cease drawing the Special Allowance immediately once I and/or my spouse begin(s) to receive any form of housing benefits in cash or in kind under my / my spouse’s terms of employment with an employer.",
        note7: "I agree to repay the Governemnt immediately if any overpayment of fringe benefits under the NET Scheme is made. The Government reserves the right to deduct from my Salaries and recover from my accrued benefits derived from voluntary contributions under any provident fund scheme any amount that it may have overpaid me, together with the interest accrued on such amount, as appropriate, from the date on which the overpayment was made to the date of deduction/the date that the amount is recovered, and all costs and expenses incurred in recovery. I also agree that the Government may set-off any sums due from me against any sums due to me.",
        note8One:
            "My consent is hereby given to the EDB, in assessing my eligibility for the fringe benefits under the NET Scheme, to check and match my personal data relating to this application (including but not limited to the personal data given on this application form and other relevant documents submitted) with my personal data collected for any other purpose (whether it is by manual means). I hereby authorise the EDB to approach other government departments, public/private organisations, or employer(s), landlord(s) or solicitor(s) concerned and expressly agree that they may give access to the EDB my personal data they possess, so that the EDB can use such data for the purpose of processing my application, ascertaining my compliance with the rules of the NET Scheme and/or taking appropriate actions against me if necessary.",
        note8Two:
            "Our consent is hereby given to the EDB, in assessing my eligibility for the fringe benefits under the NET Scheme, to check and match our personal data relating to this application (including but not limited to the personal data given on this application form and other relevant documents submitted) with our personal data collected for any other purpose (whether it is by manual means). We hereby authorise the EDB to approach other government departments, public/private organisations, or employer(s), landlord(s) or solicitor(s) concerned and expressly agree that they may give access to the EDB our personal data they possess, so that the EDB can use such data for the purpose of processing my application, ascertaining my compliance with the rules of the NET Scheme and/or taking appropriate actions against us if necessary.",
        note9One:
            "I agree that my personal data relating to this application (including but not limited to the personal data given on this application form and other relevant documents submitted) can be used by the EDB in activities relating to the administration of the fringe benefits under the NET Scheme and may be disclosed to other connected bodies for such purposes.",
        note9Two:
            "We agree that our personal data relating to this application (including but not limited to the personal data given on this application form and other relevant documents submitted) can be used by the EDB in activities relating to the administration of the fringe benefits under the NET Scheme and may be disclosed to other connected bodies for such purposes.",
        note10: "I understand that it will not be possible to process my application if I fail to provide the information requested.",
        note11One:
            "I have read, understand and agree to the Personal Information Collection Statement in the Appendix of this application form.",
        note11Two:
            "We have read, understand and agree to the Personal Information Collection Statement in the Appendix of this application form.",

        spouseSign: "Signature of spouse",
        schoolName: "school name",
        name: "name",
        textBeforeSec1:
            "I hereby apply for Special Allowance for Native-speaking English Teachers employed under",
        netSchemePrimaryOrSecondary:
            "the NET Scheme in Primary Schools / the Enhanced NET Scheme in Secondary Schools",
        netSchemePrimary: "the NET Scheme in Primary Schools",
        netSchemePrimary1: "under the NET Scheme in Primary Schools",
        netSchemeSecondary: "the Enhanced NET Scheme in Secondary Schools",
        netSchemeSecondary1:
            "under the Enhanced NET Scheme in Secondary Schools",
        textAfterSec1: ".",
        textBeforeSec2:
            "I declare that I am not receiving a Special Allowance under",
        textAfterSec2:
            "or any other financial assistance/allowance/benefits from the Government of the Hong Kong Special Administrative Region or other sources to rent or acquire accommodation in Hong Kong.",
        mySpouse: "Full name of my spouse",
        hkidMySpouse: "Hong Kong Identity Card Number (if any)",
        textBeforeSec3Declare1:
            "I declare that my spouse of particulars stated above",
        textAfterSec3Declare1:
            "employed under the Enhanced NET Scheme in Secondary Schools or the NET Scheme in Primary Schools. If the answer is in the affirmative, please provide the employment details of your spouse as specified below:",
        schoolNameMySpouse: "Name of school",
        contractPeriodFrom: "Contract period: from",
        contractPeriodTo: "to",
        textBeforeSec3Declare2:
            "I declare that my spouse is not receiving a Special Allowance",
        textAfterSec3Declare2:
            "or any other financial assistance/allowance/benefits from the Government of the Hong Kong Special Administrative Region or other sources to rent or acquire accommodation in Hong Kong. I undertake to inform you and to cease drawing the Special Allowance immediately once my spouse begins to receive such financial assistance/allowance/benefits.",
        textBeforeSec4:
            "I agree to abide by the provisions of the Special Allowance for Native-speaking English Teachers employed",
        textAfterSec4: ".",
        sec5: "I undertake to report to the school any changes of my marital status and family particulars that might affect my entitlement to the Special Allowance.",
        textBeforeSec6:
            "I confirm that I have read and understood the EDB Circular No.",
        sec6Primary:
            "{{circularNoPrimary }} including the Notes for Completing PNET-Forms",
        sec6Secondary:
            "{{circularNoSecondary}} including the Notes for Completing NET-Forms",
        textAfterSec6:
            "A-E and the stipulations related to Special Allowance in the Memorandum on the Terms and Conditions of Service.",
        hkid: "Hong Kong Identity Card Number (Mandatory to be provided once available)",
        fullNameOfNET: "Full name of NET",
        givenName: "(Given names)",
        surname: "(Surname)",
        selectSchoolType: "Please select the school type",
        partII: "Section 4: Certification by Applicant’s School(To be completed by aided schools/special schools with primary/secondary section only) (For primary and secondary)",
        partIITo: "To:",
        address1: "Secretary for Education",
        address2: "[Attn: NET Administration Team, Education Bureau]",
        address3: "Room W304, 3/F, West Block",
        address4: "Education Bureau Kowloon Tong Education Services Centre",
        address5: "19 Suffolk Road, Kowloon Tong, Kowloon",
        iCertify: "I certify that the applicant",
        is: "(Full name) is",
        textBeforeDate1: "appointed as a Native-speaking English Teacher under",
        textBeforeDate2: "in my school from",
        to: "to",
        fullStop: ".",
        textBeforePreviousContractDate:
            "(For the contract renewed/appointment contract period extended, the previous appointment/extension contract period was from",
        textAfterPreviousContractDate: "); and",
        textBeforeSpecialAllowance:
            "eligible for the grant of Special Allowance in the amount of HK$",
        specialAllowance: "{{specialAllowance}}",
        specialAllowanceNet: "{{specialAllowanceNet}}",
        textAfterSpecialAllowance:
            "each month as specified in the NET’s contract with effect from",
        textAfterDate:
            "(i.e. the date when the appointment/extension contract period starts).",
        isApproved: "is approved.",
        nameOf: "Name of",
        supervisorOrPrincipal: "supervisor/principal",
        nameOfSchool: "Name of school",
        schoolCode: "School code",
        schoolAddress: "School address",
        faxNo: "Fax no.",
        contactPerson: "Contact person for enquiry",
        telNo: "Tel. no.",
        postOfContactPerson: "Post of contact person",
        partIII:
            "Section 5: Certification by Applicant’s School (To be completed and retained by caput schools) (For secondary school only)",
        textBeforeSpecialAllowanceCaput:
            "The grant of Special Allowance to the NET in the amount of HK$",
        grateful: "I should be grateful if you would arrange the payment.",
        note1: "Please note",
        confirm: "Confirm",
    },

    formContent: {
        primaryOrSecondaryOption: {
            primary:
                "Native-speaking English Teacher (NET) Scheme in Primary Schools Application for Special Allowance",
            secondary:
                "Enhanced Native-speaking English Teacher (NET) Scheme in Secondary Schools Application for Special Allowance",
        },
        sec3Option: {
            single: "I am single.",
            married:
                "I am married and my spouse’ particulars are provided as follows:",
        },
        isOrNotOption: {
            is: "is",
            not: "is not",
        },
        supervisorOrPrincipalOption: {
            supervisor: "supervisor",
            principal: "principal",
        },
        titleOption: {
            Mr: "Mr.",
            Mrs: "Mrs.",
            Ms: "Ms.",
            Miss: "Miss.",
        },
        aidedOrCaputOption: {
            aided: "Aided schools/special school",
            caput: "Caput school",
        },
    },
    errorMsg: {
        schoolCode: "School code must be exactly 4 digits",
        telNo: "Telephone number must be exactly 8 digits",
        faxNo: "Fax number must be exactly 8 digits",
        hasAuth:
            "The current login account does not have permission to approve the form, please change your account.",
    },
};

export default Form034EN;
